function SalesIcon() {
	return (
		<svg
			width="82"
			height="81"
			viewBox="0 0 82 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.5"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M81.0776 45.5555C82.4374 53.7426 78.0096 61.8267 72.2775 67.8257C66.7974 73.561 59.0695 75.6605 51.2189 76.8048C42.4636 78.0809 33.6407 78.6654 25.7787 74.603C15.2929 69.1849 3.15827 62.6247 1.23937 50.9799C-0.746037 38.9313 8.33424 28.2277 16.6664 19.3049C24.6541 10.7512 34.6742 0.655642 46.1699 2.86494C57.2196 4.98851 58.6629 20.0335 65.7862 28.7449C70.771 34.8411 79.7874 37.7882 81.0776 45.5555Z"
				fill="#C8E4FF"
			/>
			<path
				d="M49.99 24.5H29.99C22.33 24.5 20.19 26.34 20.01 33.5C23.87 33.5 26.99 36.64 26.99 40.5C26.99 44.36 23.87 47.48 20.01 47.5C20.19 54.66 22.33 56.5 29.99 56.5H49.99C57.99 56.5 59.99 54.5 59.99 46.5V34.5C59.99 26.5 57.99 24.5 49.99 24.5Z"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M33.9866 24.5V31.5"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M33.9866 49.5V56.5"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M46.05 35.1601L47.29 37.6601C47.41 37.9001 47.65 38.0801 47.91 38.1201L50.67 38.5201C51.35 38.6201 51.63 39.4601 51.13 39.9401L49.13 41.8801C48.93 42.0601 48.85 42.3401 48.89 42.6201L49.37 45.3601C49.49 46.0401 48.77 46.5601 48.17 46.2401L45.71 44.9401C45.47 44.8201 45.17 44.8201 44.93 44.9401L42.47 46.2401C41.85 46.5601 41.15 46.0401 41.27 45.3601L41.75 42.6201C41.79 42.3401 41.71 42.0801 41.51 41.8801L39.53 39.9401C39.03 39.4601 39.31 38.6201 39.99 38.5201L42.75 38.1201C43.03 38.0801 43.25 37.9201 43.37 37.6601L44.59 35.1601C44.87 34.5401 45.75 34.5401 46.05 35.1601Z"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default SalesIcon;
